<template>
  <div class="bar-percentage-documentation">
    <h1>Default component</h1>
    <adx-barpercentage class="percentage" :title="title1" :percentageData="percentages1"/>
    <h1>Custom component 1</h1>
    <adx-barpercentage class="percentage" :title="title2" :percentageData="percentages2" :legendStyle="legendStyle1"/>
    <h1>Component with Unavailable data</h1>
    <adx-barpercentage class="percentage" :title="`Hobby`" :percentageData="percentages3"/>
    <h1>Custom component 2</h1>
    <adx-barpercentage class="percentage" :title="title2" :percentageData="percentages2" :legendStyle="legendStyle2" 
      :isTopLegends="true" 
      :wrapperStyle="wrapperStyle"
      :percentageStyle="percentageStyle"/>
  </div>
</template>

<script>
import BarPercentage from '@/components/BarPercentage'

export default {
  name: 'adx-barpercentage-documentation',
  components: {
    'adx-barpercentage': BarPercentage
  },
  props: {

  },
  data() {
    return {
      title1: "Gender",
      title2: "Age",
      percentages3: [],
      percentages1: [
        {
          header: 'Male',
          percent: 30,
          color: "#FF2D55"
        },
        {
          header: 'Female',
          percent: 20,
          color: "#3AAF4E"
        },
        {
          header: 'Other',
          percent: 50,
          color: "#007AFF"
        },
      ],
      percentages2: [
        {
          header: '15-24',
          percent: 40,
          color: "#FF2D55"
        },
        {
          header: '25-34',
          percent: 20,
          color: "#ff5777"
        },
        {
          header: '35-44',
          percent: 15,
          color: "#ff8199"
        },
        {
          header: '45-54',
          percent: 13,
          color: "#ffabbb"
        },
        {
          header: '55-64',
          percent: 8,
          color: "#ffabbb"
        },
        {
          header: '65-74',
          percent: 4,
          color: "#ffabbb"
        },
      ],
      legendStyle1: {
        "display": "grid",
        "grid-template-columns": "repeat(4, 1fr)"
      },
      legendStyle2: {
        "display": "grid",
        "grid-template-columns": "repeat(2, 1fr)"
      },
      wrapperStyle: {
        "width": "150px"
      },
      percentageStyle: {
        "margin-bottom": "4px"
      }
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>